import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'

export const About = () => {
  useEffect(() => {
    document.title = `About | Staidium`;
  }, []);

  return (
    <>
      <Breadcrumb title='About Us' />
      <div className='static-page' style={{ paddingBottom: '0px' }}>
        <Container style={{ paddingBottom: '150px' }}>
          <Row className='align-items-center'>
            <Col lg={6}>
              <div className='about-cont text-white-style'>
                <div className='about-us-title'>
                  <h2>STAIDIUM U.S.</h2>
                  <p>
                    is a technology company that uses artificial intelligence
                    (AI) and machine learning to deliver fully-automated live
                    sports streaming and integrated coaching tools.{' '}
                  </p>
                </div>
                <p>
                  STAIDIUM is managed by veteran executives David Cochran and
                  Kevin McLaughlin of the Dallas-based Global Sports Platforms
                  (GSP), which develops sports management software platform and
                  video delivery solutions that serve the development of
                  athletes from the youth to professional levels.{' '}
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <div className='about-images s--mt--30'>
                <img
                  src='/01.jpg'
                  alt=''
                />
              </div>
            </Col>
          </Row>

          <Row className='about-list-content' style={{ marginTop: '70px' }}>
            <Col lg={4}>
              <div className='single-about-area text-white-style'>
                <h4>WHAT WE DO</h4>
                <p>
                  Provide and manage a sports entertainment and development
                  ecosystem
                </p>
                <br />
                <ul className='about-feature-list'>
                  <li>
                    <i className='zmdi zmdi-check'></i> Installation{' '}
                  </li>
                  <li>
                    <i className='zmdi zmdi-check'></i> Stream broadcast{' '}
                  </li>
                  <li>
                    <i className='zmdi zmdi-check'></i> Team / Player analysis
                  </li>
                  <li>
                    <i className='zmdi zmdi-check'></i> Coaching tools
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg={4}>
              <div className='single-about-area text-white-style'>
                <h4>WHY WE ARE DIFFERENT</h4>
                <p>
                  We unify a fragmented industry with our one-stop-shop approach
                  - using artificial intelligence and machine learning as the
                  backbone to our streaming platform and integrated coaching
                  tools.
                </p>
                <p>
                  STAIDIUM is a subsidiary of the Germany-based SPORTTOTAL AG, a
                  technology and media company on a growth path in the rapidly
                  scalable digital business with streaming platforms, in the
                  high-margin international project business, as well as in the
                  live events business.{' '}
                </p>
              </div>
            </Col>

            <Col lg={4}>
              <div className='single-about-area text-white-style'>
                <h4>Our Mission</h4>
                <p>
                  STAIDIUM is the future of fully-automated sports streaming.
                  Using artificial intelligence and machine learning, our
                  state-of-the-art camera and streaming platform deliver
                  professionally-produced broadcasts and integrated coaching
                  tools all without requiring manual interaction.{' '}
                </p>
                <br />
                <p>Let our technology give your team a competitive edge.</p>
              </div>
            </Col>
          </Row>
        </Container>

        <div
          className='video-area section-pt section-pb-b bg-black-2'
          style={{
            backgroundColor: '#12222d',
            paddingBottom: '110px',
            paddingTop: '110px'
          }}>
          <Container>
            <Row>
              <Col lg={7} className='m-auto'>
                {/* Section Title */}
                <div
                  className='section-title text-center'
                  style={{ marginBottom: '80px' }}>
                  <h2
                    className='text-white'
                    style={{
                      fontWeight: 400,
                      marginTop: '-5px',
                      marginBottom: '30px',
                      paddingBottom: '30px',
                      display: 'inline-block',
                      position: 'relative'
                    }}>
                    BROAD AND DIVERSE EXPERTISE
                  </h2>
                  <p className='text-white'>
                    STAIDIUM has built a strong technological advantage driving{' '}
                    <br /> productivity and performance
                  </p>
                </div>
                {/*// Section Title */}
              </Col>
            </Row>

            <Row>
              <Col lg={12} className='text-center'>
                <div className='video-inner-wrap'>
                  <img
                    src='/Video_Laptop.png'
                    width={'75%'}
                    alt=''
                  />
                  <a href='#Video-three' className='afterglow video-btn red'>
                    <i className='zmdi zmdi-play'></i>
                  </a>
                  <video
                    id='Video-three'
                    width='960'
                    height='540'
                    className='afterglow-lightboxplayer'
                    data-autoresize='fit'
                    style={{ display: 'none' }}>
                    <source
                      src='https://staidium.com/images/staidium-brand-final.mp4'
                      type='video/mp4'
                    />
                  </video>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  )
}
